import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { 
  BsApple, 
  BsGooglePlay, 
  BsStarFill, 
  BsPeopleFill, 
  BsShieldCheck,
  BsCheckCircleFill 
} from 'react-icons/bs';

const CTASection = () => {
  const { ref, inView } = useScrollAnimation({ threshold: 0.2 });

  const appStoreUrl = "https://apps.apple.com/ng/app/nisa-care/id6767461961";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.project.nisacare";

  return (
    <section className="cta-section" ref={ref}>
      <Container>
        <div className={`cta-card animate-on-scroll fade-in-up ${inView ? 'visible' : ''}`}>
          <Row className="align-items-center">
            <Col lg={7} className="cta-content">
              <div className="cta-badge">
                <BsStarFill size={14} />
                <span>Now Available</span>
              </div>
              <h2 className="cta-title">
                Your Journey to <br />
                <span className="highlight">Holistic Wellness</span> Starts Here
              </h2>
              <p className="cta-description">
                Download Nisa Care today and experience faith-centered wellness 
                designed specifically for Muslim women. Track your cycle, stay 
                connected to your faith, and join a supportive community.
              </p>
              <div className="cta-features">
                <div className="cta-feature-item">
                  <BsCheckCircleFill className="cta-feature-icon" />
                  <span>100% Private & Secure</span>
                </div>
                <div className="cta-feature-item">
                  <BsCheckCircleFill className="cta-feature-icon" />
                  <span>Faith-Aware Guidance</span>
                </div>
                <div className="cta-feature-item">
                  <BsCheckCircleFill className="cta-feature-icon" />
                  <span>Free to Download</span>
                </div>
              </div>
              <div className="cta-buttons">
                <a 
                  href={appStoreUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="cta-app-btn cta-apple-btn"
                  aria-label="Download on the App Store"
                >
                  <BsApple size={22} />
                  <span>
                    <small>Download on the</small>
                    <strong>App Store</strong>
                  </span>
                </a>
                <a 
                  href={playStoreUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="cta-app-btn cta-google-btn"
                  aria-label="Get it on Google Play"
                >
                  <BsGooglePlay size={22} />
                  <span>
                    <small>Get it on</small>
                    <strong>Google Play</strong>
                  </span>
                </a>
              </div>
            </Col>
            <Col lg={5} className="cta-image-col">
              <div className="cta-phone-mockup">
                <div className="cta-phone-frame">
                  <img 
                    src="/images/screenshots/screenshot-1.png" 
                    alt="Nisa Care App Preview" 
                    className="cta-phone-img"
                    loading="lazy"
                  />
                </div>
                {/* Floating badges with real icons */}
                <div className="cta-float-badge cta-float-1">
                  <BsStarFill className="cta-float-icon" />
                  <span>4.8★ Rating</span>
                </div>
                <div className="cta-float-badge cta-float-2">
                  <BsPeopleFill className="cta-float-icon" />
                  <span>50K+ Users</span>
                </div>
                <div className="cta-float-badge cta-float-3">
                  <BsShieldCheck className="cta-float-icon" />
                  <span>100% Private</span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default CTASection;